import { IChatConfig } from "@interfaces/chat/chatConfig"
import { setChatConfig } from "@redux/slices/socketChat/chatConfig"
import { RootState } from "@redux/store"
import { getChatSettings } from "@services/chat/chat_config"
import { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

const useUserChatConfig = () => {
    const [ configData, setConfigData ] = useState<IChatConfig | null>(null)
    const [ error, setError ] = useState<unknown | null>(null)
    const [ isLoading, setIsLoading ] = useState<boolean>(false)
    const [ hasLoaded, setHasLoaded ] = useState<boolean>(false)
    const session = useSelector((state: RootState) => state.session)
    const dispatch = useDispatch();

    const getConfigChat = useCallback(async () => {
        if(!session?.email) return
        try 
        {
            setIsLoading(true);
            const configDataRes = await getChatSettings(session.email);
            setConfigData(configDataRes);

            if (configDataRes && configDataRes.typePerson)
            {
                dispatch(setChatConfig(configDataRes));
            }
        } 
        catch (error) 
        {
            console.error("getConfigChat", error);
            setError(error);
        }
        finally
        {
            setIsLoading(false);
            setHasLoaded(true);
        }
    }, [dispatch, session.email]);

    useEffect(() => {
        getConfigChat();
    }, [getConfigChat])

    return { configData, error, isLoading, reloadData: getConfigChat, hasLoaded }
}

export default useUserChatConfig
